import React from 'react'
import formatMessage from 'format-message'
import './ExpandableIcon.css'

export default function ExpandableIcon({ onClick }) {
  return (
    <button
      aria-label={formatMessage('Expand comment')}
      onClick={onClick}
      className="ExpandableIcon"
    >
      [...]
    </button>
  )
}
